/**
 * Page Loading Screen - Hide Logic
 * The inline script in theme.liquid handles showing the overlay
 * This script handles hiding it after minimum time + page load
 */

class PageLoadingScreen {
  constructor() {
    this.overlay = document.getElementById('pageLoadingScreen');
    
    // Exit if overlay doesn't exist or wasn't shown by inline script
    if (!this.overlay || !this.overlay.classList.contains('active')) return;
    
    this.minTime = parseInt(this.overlay.dataset.minTime, 10) * 500; // Convert to milliseconds (but actually make it half seconds)
    this.storageKey = 'pageLoadingScreenCount';
    
    this.startTime = Date.now();
    this.pageLoaded = false;
    this.minTimeElapsed = false;
    
    this.init();
  }
  
  init() {
    // Set up minimum time timer
    setTimeout(() => {
      this.minTimeElapsed = true;
      this.checkAndHide();
    }, this.minTime);
    
    // Listen for page load
    if (document.readyState === 'complete') {
      this.pageLoaded = true;
      this.checkAndHide();
    } else {
      window.addEventListener('load', () => {
        this.pageLoaded = true;
        this.checkAndHide();
      });
    }
    
    // Increment view count now that we've shown the overlay
    this.incrementViewCount();
  }
  
  incrementViewCount() {
    try {
      const count = sessionStorage.getItem(this.storageKey);
      const currentCount = count ? parseInt(count, 10) : 0;
      sessionStorage.setItem(this.storageKey, (currentCount + 1).toString());
    } catch (e) {
      console.warn('Could not update session storage:', e);
    }
  }
  
  checkAndHide() {
    // Only hide when both conditions are met
    //if (this.pageLoaded && this.minTimeElapsed) {

    //just do the timer
    if (this.minTimeElapsed) {
      this.hide();
    }
  }
  
  hide() {
    // Add fade-out class to trigger opacity transition
    this.overlay.classList.add('page-loading-screen--fade-out');
    
    // Remove body class to restore scrolling
    document.body.classList.remove('page-loading-screen-active');
    
    // After fade animation completes, remove active class and set display: none
    setTimeout(() => {
      this.overlay.classList.remove('active');
      this.overlay.classList.remove('page-loading-screen--fade-out');
    }, 600); // Match CSS transition duration (0.5s = 500ms)
  }
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new PageLoadingScreen();
  });
} else {
  new PageLoadingScreen();
}

